import React, { Component } from 'react';

// import externalConfiguration from '../external-configuration';

import defaultProps from './default-props';
import propTypes from './prop-types';
import './tagging-transcription.css';

const displayName = 'TaggingTranscription';

class TaggingTranscription extends Component {
  constructor(props) {
    super(props);
    const taggings = Object.keys( this.props.taggings);
    let currentTagging;
    taggings.forEach( tagging => {
      if( tagging === this.props.basePlayerOptions.defaultLanguage) {
        currentTagging = tagging;
      }
    })
    if( currentTagging === undefined) {
      currentTagging = taggings.length > 0 ? taggings[0] : -1;
    }
    this.state = {
      currentTime: 0,
      currentTagging,
    }
  }
  componentWillMount() {
  }
  renderTagginableElement( type, key, element) {
    let className;
    const activeElement = (this.state.currentTime >= element.begin || isNaN( element.begin)) && (this.state.currentTime < element.end || isNaN( element.end));
    if( type === 'chapter') {
      className = activeElement ? 'transcript-title-active' : 'transcript-title';
      return (
        <h4 key={key} onClick={ () => this.props.player.seek( element.begin | 0)}
          className={ className + ' ' + this.props.taggingOptions.taggingStyle}
          dangerouslySetInnerHTML={{ __html: element.text}}
        ></h4>
      );
    }
    className = activeElement ? 'transcript-text-active' : 'transcript-text';
    return (
      <span key={key} onClick={ () => this.props.player.seek( element.begin | 0)}
        className={ className + ' ' + this.props.taggingOptions.taggingStyle}
        dangerouslySetInnerHTML={{ __html: element.text}}
      ></span>
    );
  }
  renderTabContent( tagging, chapters) {
    let rended = [], tag = 0, chapter = 0;
    while( tag < tagging.length && chapter < chapters.length) {
      if( chapters[chapter].begin <= tagging[tag].begin || isNaN( chapters[chapter].begin) ) {
        rended.push( this.renderTagginableElement( 'chapter', 'chapter' + chapter, chapters[chapter]));
        chapter += 1;
      } else {
        rended.push( this.renderTagginableElement( 'text', 'text' + tag, tagging[tag]));
        tag += 1;
      }
    }
    while( chapter < chapters.length) {
      rended.push( this.renderTagginableElement( 'chapter', 'chapter' + chapter, chapters[chapter]));
      chapter += 1;
    }
    while( tag < tagging.length) {
      rended.push( this.renderTagginableElement( 'text', 'text' + tag, tagging[tag]));
      tag += 1;
    }
    return rended;
  }
  render() {
    if( this.props.player) {
      this.props.basePlayer.uniqueOnTime = (e) => {
        this.setState( { currentTime: e.position});
      }
      let currentTagging;
      if( this.state.currentTagging !== -1) {
        currentTagging = this.props.taggings[ this.state.currentTagging];
      } else {
        currentTagging = [];
      }
      return (
        <div className={'sidebar ' + this.props.taggingOptions.taggingStyle} style={{ width: window.innerWidth - this.props.customProps.width, height: this.props.customProps.height}}>
          <div className='transcript'>
            <div className='tab'>
              { Object.keys( this.props.taggings).map( (label, i) => {
                const className = this.state.currentTagging === label ? 'tablinks-active' : 'tablinks';
                return <button key={i} className={className} onClick={ () => { this.setState( { currentTagging: label})}}> {label} </button>;
              }) }
            </div>
            <div className='tabcontent'>
              {  this.renderTabContent( currentTagging, this.props.chapters) }
            </div>
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

TaggingTranscription.defaultProps = defaultProps;
TaggingTranscription.displayName = displayName;
TaggingTranscription.propTypes = propTypes;
export default TaggingTranscription;



// WEBPACK FOOTER //
// ./src/tagging-transcription/tagging-transcription.js